import React from 'react';
import { Redirect, Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";
import { useCanManageUserGroups } from 'components/usergroup/hooks';
import { useCanCreateUsers, useCanAssignUserGroups } from 'components/users/hooks';

export default function UsersRoute() {

    const { path } = useRouteMatch();
    const canManageUserGroups = useCanManageUserGroups();
    const canCreateUsers = useCanCreateUsers();
    const canAssignUserGroups = useCanAssignUserGroups();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Users canCreateUsers={ canCreateUsers } />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Users canCreateUsers={ canCreateUsers } />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Users canCreateUsers={ canCreateUsers } />
            </Route>
            <Route path={ `${ path }/create` } exact>
                { ({ match, history }) => canCreateUsers
                    ? <Pages.User
                        match={ match }
                        history={ history }
                        canCreateUsers={ canCreateUsers }
                        canAssignUserGroups={ canAssignUserGroups }
                        canManageUserGroups={ canManageUserGroups } />
                    : <Redirect to={ path } /> }
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match, history }) => (
                    <Pages.User
                        match={ match }
                        history={ history }
                        canCreateUsers={ canCreateUsers }
                        canAssignUserGroups={ canAssignUserGroups }
                        canManageUserGroups={ canManageUserGroups }
                        exact />
                ) }
            </Route>
        </Switch>
    );
}

